import React from 'react'
import PropTypes from 'prop-types'
import {
    BreadcrumbItem as ChakraBreadcrumbItem,
    BreadcrumbLink as ChakraBreadcrumbLink
} from '@chakra-ui/react'
import Link from '../link'

// helper to create an unstyled link as chakra passes the styles as __css prop to the link
const UnstyledLink = (props) => <Link {...props} variant="unstyled" size="unstyled" />

const BreadcrumbItem = ({
    children,
    href,
    isLastChild,
    // default to true when the item is the last child
    isCurrentPage = isLastChild,
    ...props
}) => {
    return (
        <ChakraBreadcrumbItem {...props} isCurrentPage={isCurrentPage} isLastChild={isLastChild}>
            <ChakraBreadcrumbLink {...(href && {as: UnstyledLink, to: href})}>
                {children}
            </ChakraBreadcrumbLink>
        </ChakraBreadcrumbItem>
    )
}

BreadcrumbItem.propTypes = {
    children: PropTypes.node,
    href: PropTypes.string,
    isCurrentPage: PropTypes.bool,
    isLastChild: PropTypes.bool
}

export default BreadcrumbItem
